/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import QuickLinks from '../ui/quicklinks';
import adhesion from 'assets/images/footer-adhesion.gif';
import arrepentimiento from 'assets/images/footer-arrepentimiento.gif';
import usuarios from 'assets/images/footer-usuarios.gif';
import './index.css';

function Footer() {
  const desktopWidth = 1100;
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > desktopWidth);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > desktopWidth);
    };
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
    {isDesktop && 
    <>
      <QuickLinks />
      <footer>
        <div className="wrapper">
          <nav>
            <div>
              <h4>Institucional</h4>
              <ul>
                <li><a href="#">Autoridades</a></li>
                <li><a href="#">Carta Orgánica</a></li>
                <li><a href="#">Organigrama</a></li>
                <li><a href="#">Estados financieros</a></li>
                <li><a href="#">Disciplina de Mercado</a></li>
                <li><a href="#">Gobierno Institucional</a></li>
                <li><a href="#">Prensa y Noticias</a></li>
                <li><a href="#">Trabajar en Banco Provincia</a></li>
                <li><a href="#">Sostenibilidad</a></li>
              </ul>
            </div>
            <div>
              <h4>Información legal</h4>
              <ul>
                <li><a href="#">Atención al Usuario de Servicios Financieros</a></li>
                <li><a href="#">Información al Usuario de Servicios Financieros</a></li>
                <li><a href="#">Régimen de transparencia del BCRA</a></li>
                <li><a href="#">Portal del Cliente Bancario</a></li>
                <li><a href="#">AlyC</a></li>
                <li><a href="#">Debida Diligencia</a></li>
                <li><a href="#">PEPs y Sujetos Obligados</a></li>
                <li><a href="#">Defensa al Consumidor</a></li>
                <li><a href="#">Protección de Datos Personales</a></li>
              </ul>
            </div>
            <div>
              <h4>Ayuda y guías</h4>
              <ul>
                <li><a href="#">App Cuenta DNI</a></li>
                <li><a href="#">Simuladores Plazos Fijos</a></li>
                <li><a href="#">Simuladores Préstamos Personales</a></li>
                <li><a href="#">Asesoramiento sobre deudas con atraso</a></li>
                <li><a href="#">ATM personas con discapacidad visual</a></li>
                <li><a href="#">Centro de Seguridad</a></li>
                <li><a href="#">Protección de Datos Personales</a></li>
              </ul>
            </div>
            <div>
              <h4>Otros sitios de interés</h4>
              <ul>
                <li><a href="#">Compras y licitaciones</a></li>
                <li><a href="#">Oportunidades inmobiliarias</a></li>
                <li><a href="#">Provincia Servicios Financieros</a></li>
                <li><a href="#">Grupo Provincia</a></li>
                <li><a href="#">Museo Banco Provincia</a></li>
                <li><a href="#">Cátedra Arturo Jauretche</a></li>
                <li><a href="#">Provincia Microcréditos</a></li>
                <li><a href="#">Fundación Banco Provincia</a></li>
                <li><a href="#">Buenos Aires Provincia</a></li> 
              </ul>
            </div>
          </nav>
          <div className='botonera'>
            <div>
              <p>Seguinos en:</p>
              <ul className='social'>
                <li><a href="https://www.google.com" target='_blank' rel="noreferrer" className='fb'>Facebook</a></li>
                <li><a href="https://www.google.com" target='_blank' rel="noreferrer" className='tw'>Twitter</a></li>
                <li><a href="https://www.google.com" target='_blank' rel="noreferrer" className='in'>Instagram</a></li>
                <li><a href="https://www.google.com" target='_blank' rel="noreferrer" className='yt'>YouTube</a></li>
                <li><a href="https://www.google.com" target='_blank' rel="noreferrer" className='ln'>Linkedin</a></li>
              </ul>
            </div>
            <a href="https://www.google.com" target='_blank' rel="noreferrer">
              <img src={arrepentimiento} alt="Botón de arrepentimiento" />
            </a>
            <a href="https://www.google.com" target='_blank' rel="noreferrer">
              <img src={adhesion} alt="Contratos de adhesión" />
            </a>
            <a href="https://www.google.com" target='_blank' rel="noreferrer">
              <img src={usuarios} alt="Usuarios Financieros" />
            </a>
          </div>
          <div>
            <div className='copy'>
              <p>Términos y condiciones de navegabilidad del sitio web</p>
              <p>© 2024 - Banco de la Provincia de Buenos Aires - Casa Matriz: Calle 7 N° 726 (B1900TFS) La Plata, Buenos Aires, Argentina.</p>
            </div>
          </div>
        </div>
      </footer>
    </>}
      
    </>
  );
}

export default Footer;